module.exports = __webpack_public_path__ + "static/media/tyre-red-three4.64a6c5f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-red-three4.png
// module id = 345
// module chunks = 0